import React from 'react'
import PageContent from '../../../common/components/atom/PageContent/PageContent'
import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import SectionTitle from '../../../common/components/atom/SectionTitle/SectionTitle'
import CreateUserLinkList from '../../../features/createUserLink/components/CreateUserLinkList'

export default function InvitListPage() {
  return (
    <PageContent>
      <HeaderTitleContent>Invitations</HeaderTitleContent>
      <CreateUserLinkList.AddNewBtnModal />
      <div style={{ marginTop: 50 }} />
      <SectionTitle iconType={"link-crooked"}>Lien d'invitations</SectionTitle>
      <div style={{ width: "100%", maxWidth: 1000 }}>
        <CreateUserLinkList.Filter />
        <CreateUserLinkList.List pageSize={8} />
      </div>
    </PageContent>
  )
}
